import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getFrutas, updateFruta, insertFruta, deleteFruta } from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_FRUTAS() {
  try {
    const frutasData = yield call(getFrutas)
    if (frutasData.ok) {
      yield put({
        type: actions.FRUTAS_LOAD_SUCCEEDED,
        payload: frutasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar frutas')
      put({
        type: actions.FRUTAS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FRUTAS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_FRUTA(action) {
  try {
    const frutaObj = yield call(insertFruta, action.payload)
    if (frutaObj.ok) {
      putMessage(messageType.SUCCESS, 'Fruta creada correctamente')
      yield put({
        type: actions.FRUTA_INSERT_SUCCEEDED,
        payload: frutaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Fruta')
      yield put({
        type: actions.FRUTA_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Fruta')
    yield all([
      put({
        type: actions.FRUTA_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FRUTA(action) {
  try {
    const frutaObj = yield call(updateFruta, action.payload)
    if (frutaObj.ok) {
      putMessage(messageType.SUCCESS, 'Fruta modificada correctamente')
      yield put({
        type: actions.FRUTA_UPDATE_SUCCEEDED,
        payload: frutaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Fruta')
      yield put({
        type: actions.FRUTA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Fruta')
    yield all([
      put({
        type: actions.FRUTA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_FRUTA(action) {
  try {
    const frutaResult = yield call(deleteFruta, action.payload)
    if (frutaResult.ok) {
      putMessage(messageType.SUCCESS, 'Fruta eliminada correctamente')
      yield put({
        type: actions.FRUTA_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Fruta')
      yield put({
        type: actions.FRUTA_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Fruta')
    yield all([
      put({
        type: actions.FRUTA_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FRUTAS_LOAD_REQUESTED, GET_FRUTAS),
    takeEvery(actions.FRUTA_INSERT_REQUESTED, INSERT_FRUTA),
    takeEvery(actions.FRUTA_UPDATE_REQUESTED, UPDATE_FRUTA),
    takeEvery(actions.FRUTA_DELETE_REQUESTED, DELETE_FRUTA),
  ])
}
